import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import zoomSdk from "@zoom/appssdk";
import { endpoint } from '../utils/utils';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import LinkIcon from '@mui/icons-material/Link';
import GroupsIcon from '@mui/icons-material/Groups';
import HistoryIcon from '@mui/icons-material/History';

export const OnboardingView = ({setIsOnboarded}) => {
  const { t } = useTranslation('zoom');

  return (
    <Box
      sx={{
        p: 3,
        textAlign: 'center',
        maxWidth: '800px',
        margin: '0 auto'
      }}
    >
      <Typography variant="h3" gutterBottom sx={{ borderBottom: '1px solid #444444', pb: 1 }}>
        {t('onboarding.welcome')}
      </Typography>

      <Typography variant="h5" sx={{ mb: 2 }}>
        {t('onboarding.subtitle')}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 6,
          textAlign: 'left',
          backgroundColor: 'background.paper',
          p: 2,
          borderRadius: 1,
          mb: 2
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" gutterBottom>
            {t('onboarding.featuresTitle')}
          </Typography>
          <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              <VerifiedUserIcon fontSize="large" sx={{ color: 'info.main', mr: 2 }} />
              {t('onboarding.feature1')}
            </li>
            <li style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              <LinkIcon fontSize="large" sx={{ color: 'info.main', mr: 2 }} />
              {t('onboarding.feature2')}
            </li>
            <li style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              <GroupsIcon fontSize="large" sx={{ color: 'info.main', mr: 2 }} />
              {t('onboarding.feature3')}
            </li>
            <li style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              <HistoryIcon fontSize="large" sx={{ color: 'info.main', mr: 2 }} />
              {t('onboarding.feature4')}
            </li>
          </ul>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" gutterBottom>
            {t('onboarding.gettingStarted')}
          </Typography>
          <ol style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}>
            <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 12 }}>
              <span style={{ fontSize: 28, fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: 700, color: '#407796', minWidth: 32, textAlign: 'center', lineHeight: 1 }}>1.</span>
              <span style={{ marginLeft: 12 }}>{t('onboarding.step1')}</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 12 }}>
              <span style={{ fontSize: 28, fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: 700, color: '#407796', minWidth: 32, textAlign: 'center', lineHeight: 1 }}>2.</span>
              <span style={{ marginLeft: 12 }}>{t('onboarding.step2')} <a href="#" style={{ color: '#407796' }} onClick={async () => { await zoomSdk.openUrl({ url: `https://${endpoint()}/zoom-phone/app-store`}); }}>{t('onboarding.step2link')}</a>.</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 12 }}>
              <span style={{ fontSize: 28, fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: 700, color: '#407796', minWidth: 32, textAlign: 'center', lineHeight: 1 }}>3.</span>
              <span style={{ marginLeft: 12 }}>{t('onboarding.step3')}</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 12 }}>
              <span style={{ fontSize: 28, fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: 700, color: '#407796', minWidth: 32, textAlign: 'center', lineHeight: 1 }}>4.</span>
              <span style={{ marginLeft: 12 }}>{t('onboarding.step4')}</span>
            </li>
          </ol>
        </Box>
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          localStorage.setItem('isPhoneAppOnboarded', 'true');
          setIsOnboarded(true);
        }}
      >
        {t('onboarding.button')}
      </Button>
    </Box>
  );
};
